import { render } from "./PlanSetupComponent.vue?vue&type=template&id=0c4323d8&scoped=true"
import script from "./PlanSetupComponent.vue?vue&type=script&lang=js"
export * from "./PlanSetupComponent.vue?vue&type=script&lang=js"

import "./PlanSetupComponent.vue?vue&type=style&index=0&id=0c4323d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4323d8"]])

export default __exports__